import {PageProps} from '@/types';
import styles from './List.module.scss'
import Page from "@/Pages/Page";
import {FormEventHandler, useState} from "react";
import Search from "@/Atoms/Search/Search";
import Select from "@/Atoms/Select/Select";

import Pagination from "@/Molecules/Pagination/Pagination";
import Organisation from "@/Organisms/Organisation";
import {Organisation as OrganisationType} from "@/types/Organisation";
import {relativeRoute} from "@/helpers/relativeRoute";

export default function List({ baseUrl, organisations, services, service, search: defaultSearch}: PageProps<{
  baseUrl: string,
  organisations: {
    data: [],
    last_page: number,
    current_page: number,
  },
  services: any[],
  service: string,
  search?: string,
}>) {

  const [search, setSearch] = useState(defaultSearch)
  const handleSearch: FormEventHandler = (e) => {
    e.preventDefault();
    location.href = `${baseUrl}${search ? `?search=${search}` : ''}`
  };

  const handleChangeService = (input: { label: string, value: string; }) => {

    let url = input
      ? relativeRoute('address.categorie', {service: input.value})
      : relativeRoute('adressengids')
    if (search){
      url +=  (search ? `?search=${search}` : '');
    }
    location.href = url
  }

  const handlePaginate = (page: number) => {
    let url = service
      ? relativeRoute('address.categorie', {service: service})
      : relativeRoute('adressengids')
    url +=  `?page=${page}`;
    if (search){
      url +=  (search ? `&search=${search}` : '');
    }
    location.href = url
  }

  return <Page title={'Adressen gids'} harvestId={6952}>

    <section>
      <div className="container md:flex justify-between items-end">
        <h1>Adressengids</h1>
        <div className="flex flex-col md:flex-row gap-4" >

          <Select
            defaultValue={service ? services.find((cat: { value: string; }) => cat.value === service) : ''}
            onChange={(e: any) => handleChangeService(e)}
            options={services}
            placeholder={'Welk bedrijf zoekt u?'}
            isSearchable={false}
            isClearable={true}
           dataTestid={'address-search'}/>

          <form onSubmit={handleSearch}>
            <Search
              value={search || ''}
              onChange={(input: string) => setSearch(input)}
              placeholder={'Zoeken op naam'}
            />

          </form>
        </div>
      </div>
    </section>

    <section className="bg-beige py-5">

      <div className={`container ${styles.list}`}>
        {organisations.data.map((organisation: OrganisationType, index) => <Organisation
          key={index}
          baseUrl={baseUrl}
          organisation={organisation}
        />)}

      </div>
      {organisations.data.length === 0 && <p className={'text-center pb-10'}>
        Geen resultaten gevonden in deze categorie en/of zoekopdracht
      </p>}
      <Pagination page={organisations.current_page} pages={organisations.last_page} onChange={handlePaginate} />
    </section>
  </Page>
}
